import React from "react";
import { Autocomplete, TextField } from "@mui/material";

const DecoAutocomplete = ({ labelId, value, onChange, menuItems, label }) => (
  <Autocomplete
    id={labelId}
    options={menuItems}
    value={value || ""}
    onChange={(event, newValue) => {
      onChange({ target: { value: newValue || "" } });
    }}
    renderInput={(params) => (
      <TextField {...params} label={label} variant="outlined" error={!value} />
    )}
    isOptionEqualToValue={(option, val) => {
      if (val === "" || val === null) return option === val;
      return option === val;
    }}
    disableClearable={false}
    autoHighlight
    openOnFocus
  />
);

export default DecoAutocomplete;
